module.exports = __webpack_public_path__ + "img/aboutus.0467737e.png";